<p-divider align="center">
  <span class="p-tag">{{'Version_1' | translate}}</span>
</p-divider>
@if (skeleton === true) {  
  @if (error === true) {
    <div class="text-center font-bold text-lg" style="color: red;">{{'Load_Data_KO' | translate}}</div>    
  }@else {      
    <p-skeleton width="100%" height="100%"/>
  }
}@else {  
  <table class="table head" style="font-size: 14px">
    <thead>
      <tr>
        <th width="20%">{{'Version_1' | translate}}</th>
        <th width="40%">{{'Date' | translate}}</th>
        <th>{{'Action' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (verFile of listVersion(); track verFile.name; let i = $index) {
        <tr>
          <td class="word-break-all">{{ verFile.name }}</td>
          <td class="word-break-all">{{ verFile.VerDate | date: 'dd/MM/yyyy'}}</td>
          @if (editMode === true) {
            <td style="text-align: right">
              @if (viewVer && verFile.showVer === true) {
                <i
                  class="icons8-visible margin-right iconstyle"
                  pTooltip="{{'View' | translate}}"
                  (click)="showVerFile(verFile)"
                ></i>
              }
              @if (viewVer && verFile.showVer === false) {
                <i
                  class="icons8-invisible margin-right iconstyle"
                  pTooltip="{{'Return' | translate}}"
                  (click)="showVerFile(verFile)"
                ></i>
              }
              <i
                class="icons8-t-l-charger margin-right iconstyle"
                pTooltip="{{'Dl_Ori' | translate}}"
                (click)="downloadVerFile(verFile, 'getversionfile')"
                style="color:black;"
              ></i>
              <i
                class="icons8-export-pdf margin-right iconstyle"
                pTooltip="{{'Copy_Dl' | translate}}"
                (click)="downloadVerFile(verFile, 'getversioncopy')"
                style="color:black;"
              ></i>
              @if (isLock === false && delVer) {
                <i
                  class="icons8-trash-can margin-right iconstyle"
                  pTooltip="{{'Delete' | translate}}"
                  (click)="removeVerFile(verFile)"
                  style="color:red;"
                ></i>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}

<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
